





















import { defineComponent, ref, watch } from "@vue/composition-api";
import BaseIconButton from "@/components/BaseIconButton";
import BaseList, { BaseListItem } from "@/components/BaseList";
import BaseMenu from "@/components/BaseMenu";
import { MessageSortTypeEnum } from "../types";

export default defineComponent({
  name: "MessageThreadsSort",
  components: { BaseMenu, BaseList, BaseListItem, BaseIconButton },
  props: {
    sortItems: { type: Array as () => string[], required: true },
    currentSortItem: {
      type: Number as () => MessageSortTypeEnum,
      required: true,
      validator: (v: number) => MessageSortTypeEnum[v] !== undefined,
    },
  },
  setup(props, { emit }) {
    const activeItem = ref(props.currentSortItem);

    watch(activeItem, (newValue, oldValue) => {
      if (newValue !== oldValue) {
        emit("select", newValue);
      }
    });

    return { activeItem };
  },
});
